import React from 'react';
import { Car, AlertTriangle } from 'lucide-react';

// Admin list badge: how many exact motorisations a product covers (spot sheets without compatibility)
export const CompatCoverageBadge = ({ product }) => {
  const brands = [...new Set((product.compatibility || []).map(r => r.brand))];
  const n = product.fitments_count || 0;
  if (!brands.length && !n) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-amber-50 text-amber-700" title="Aucune règle ni motorisation : le produit est affiché comme universel" data-testid={`compat-coverage-none-${product.id}`}>
        <AlertTriangle size={11} /> Sans compatibilité
      </span>
    );
  }
  return (
    <div className="space-y-1">
      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full ${n ? 'bg-[#1e3a5f] text-white' : 'bg-amber-50 text-amber-700'}`} title={n ? `${n} motorisation(s) exacte(s) affichée(s) sur la fiche` : 'Règles par marque uniquement : aucune motorisation détaillée'} data-testid={`compat-coverage-${product.id}`}>
        <Car size={11} /> {n ? `${n} motorisation${n > 1 ? 's' : ''}` : '0 motorisation'}
      </span>
      {brands.length > 0 && (
        <span className="block text-[11px] text-orange-700 truncate max-w-[160px]" title={brands.join(', ')}>
          {brands.slice(0, 3).join(', ')}{brands.length > 3 && ` +${brands.length - 3}`}
        </span>
      )}
    </div>
  );
};

export default CompatCoverageBadge;
